import { createContext } from "react";

export const Useprovider = createContext()

